@file:kotlin.js.JsExport
package com.narbase.letsgo.web.routing.domain.passenger.config

import com.narbase.letsgo.router.EndPoint
import com.narbase.letsgo.web.dto.config.TermsAndConditionsConfigDto

object GetTermsAndConditionsConfigEndpoint : EndPoint<GetTermsAndConditionsConfigEndpoint.Request, GetTermsAndConditionsConfigEndpoint.Response>() {
    class Request
    class Response(
        val termsAndConditionsDto: TermsAndConditionsConfigDto
    )
}